export default __webpack_public_path__ + "static/media/uimg.6fb57b8b.svg";